import { TFunction } from 'next-i18next'
import { getFormatedPrice } from 'src/core/helpers'
import { BankTransferType, Deposit } from 'src/core/models'
import { format } from 'date-fns'

interface BankAccountType {
  iban?: string,
  swift?: string,
  beneficiaryName: string,
  fileUrl: string
  bankName?: string
  abaRouting?: string
  account?: string
}

export const getBankAccount = (code: string, selectedCountry: 'USA' | 'SPAIN'): BankAccountType => {
  if (code === 'USD' && selectedCountry === 'USA') {
    return {
      bankName: process.env.BANK_NAME_USA,
      abaRouting: process.env.BANK_ABA_ROUTING,
      swift: process.env.BANK_USA_SWIFT,
      account: process.env.BANK_USA_ACCOUNT,
      beneficiaryName: process.env.BANK_USA_BENEFICIARY_NAME,
      fileUrl: '/accounts/files/bank_account_usd_usa.pdf'
    }
  }
  const bankData = {
    EUR: {
      iban: process.env.CBI_IBAN,
      swift: process.env.CBI_SWIFT,
      beneficiaryName: process.env.CBI_BENEFICIARY_NAME,
      fileUrl: '/accounts/files/bank_account_certificate_EUR.pdf'
    },
    USD: {
      iban: process.env.USD_CBI_IBAN,
      swift: process.env.USD_CBI_SWIFT,
      beneficiaryName: process.env.USD_CBI_BENEFICIARY_NAME,
      fileUrl: '/accounts/files/bank_account_certificate_USD.pdf'
    },
    GBP: {
      iban: process.env.GBP_CBI_IBAN,
      swift: process.env.GBP_CBI_SWIFT,
      beneficiaryName: process.env.GBP_CBI_BENEFICIARY_NAME,
      fileUrl: '/accounts/files/bank_account_certificate_GBP.pdf'
    }
  }
  return bankData[code] || bankData['EUR']
}


export const getDepositDetailsList = (
  code: string, selectedCountry: 'USA' | 'SPAIN', t: TFunction, deposit: BankTransferType
): {label: string, value: string | number}[] => {
  const useBankData = getBankAccount(code, selectedCountry)

  let bankData = [
    { label: t('Deposits.IBAN'), value: useBankData.iban },
    { label: t('Deposits.SWIFT'), value: useBankData.swift },
    { label: t('Deposits.BeneficiaryName'), value: useBankData.beneficiaryName },
  ]
  if (code === 'USD' && selectedCountry === 'USA') {
    bankData = [
      { label: t('Deposits.BankAccount.Name'), value: useBankData.bankName },
      { label: t('Deposits.BankAccount.Aba'), value: useBankData.abaRouting },
      { label: t('Deposits.SWIFT'), value: useBankData.swift },
      { label: t('Deposits.BankAccount.Account'), value: useBankData.account },
      { label: t('Deposits.BeneficiaryName'), value: useBankData.beneficiaryName },
    ]
  }
  return  [
    ...bankData,
    { label: t('Deposits.Amount'), value: getFormatedPrice(deposit?.amount, code) },
    { label: t('Deposits.Reference'), value: deposit?.internal_reference },
  ]
}


export const getDepositDetails = (t: TFunction, deposit: Deposit, code: string):
  Array<{ label: string; value: string | number }> => {
  const formattedDate = deposit.created ? format(new Date(deposit.created), 'd MMM yyyy') : deposit.created
  const kindLabel = {
    card: t('Payment.Card'),
    credit_card: t('Payment.CreditCard'),
    bank: t('Payment.Bank'),
  }[deposit?.kind] || t('Payment.Bank')
  const tag = {
    paid: { label: t('Deposits.Completed'), type: 'success' },
    pending: { label: t('Deposits.Pending'), type: 'processing' },
    canceled: { label: t('Deposits.Canceled'), type: 'error' }
  }[deposit.status]
  const statusLabel = tag ? tag.label : ''
  return [
    { label: t('Projects.Fields.Type'), value: kindLabel },
    { label: t('Deposits.Date'), value: formattedDate },
    { label: t('Deposits.Reference'), value: deposit.internal_reference },
    { label: t('Deposits.Amount'), value: getFormatedPrice(deposit?.amount, code) },
    { label: t('Projects.Currency'), value: code },
    { label: t('Deposits.Status'), value: statusLabel },
  ]
}
